// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__17Jq0","requiredAsterisk":"Info_requiredAsterisk__-_tUX"};